import React from "react";
import { observer } from "mobx-react";
import { UserSubscriptionsPreviewTemplate } from "themes/application/payment/pages";
import { UserSubscriptionsPreviewViewStore } from "application/payment/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new UserSubscriptionsPreviewViewStore(rootStore, componentProps),
    "userSubscriptionsPreviewViewStore"
)
@observer
class UserSubscriptionsPreview extends React.Component {
    render() {
        return <UserSubscriptionsPreviewTemplate {...this.props} />;
    }
}

export default UserSubscriptionsPreview;
